import React from 'react';
import { IOrder, IOrderPackingList } from '@/interfaces/order';
import TemplateHeader from './components/template-header';
import TemplateOrderInfo from './components/template-order-info';
import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { queryOrderPackingList } from '@/adapters/order';
import TemplateOrderPackingList from './components/template-order-packing-list';

interface IProps {
  data: IOrder;
  driverid?: number;
}

const TM27 = ({ data, driverid }: IProps) => {
  const { data: packingList } = useQuery<
    AxiosResponse<IOrderPackingList[]>,
    Error
  >({
    queryKey: ['get-packing-list'],
    queryFn: async () => await queryOrderPackingList(data.code),
    enabled: !!data.code,
    refetchOnWindowFocus: false,
  });

  const palletNumbers = data?.orderPallets
    ?.filter(c => c.orderDriverId == Number(driverid))
    .map(c => c.palletNumber);

  const mapPallets =
    packingList?.data?.filter(c =>
      palletNumbers.includes(c.transportTrackingNo),
    ) || [];

  return (
    <div
      style={{
        maxWidth: '209mm',
        minWidth: '209mm',
        minHeight: '296mm',
        maxHeight: '296mm',
        backgroundColor: 'white',
        margin: '0px auto',
        position: 'relative',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 10,
        paddingBottom: 10,
        pageBreakBefore: 'always',
      }}
    >
      <TemplateHeader
        description=""
        titleEn="Delivery Order"
        titleTh="Pallet Detail"
        businessUnitLogo={data.businessUnitLogo}
      />
      <TemplateOrderInfo data={data} code={data.ivNo} />
      <TemplateOrderPackingList items={mapPallets || []} />
    </div>
  );
};

export default TM27;
